import Vue from "vue";
Vue.use(require("vue-shortkey"), { prevent: ["input", "textarea"] });
